import { AnyAction } from 'redux';
type Identity = string | number;
import _ from 'lodash';
/**
 * Handles update actions for an object state with the ID as the key
 * Partial data will be merged with the old state
 * modifies isUpdating of the state
 *
 * @param baseName
 * @param initialState
 * @param options
 */
export function createUpdateWithKeyReducer<D extends { id?: any, loadingId?:string }>(
  baseName: string,
  initialState: StateWithObjectPayload<D>,
  options: ReducerOptions = {},
) {
  return function updateKeyReducer(state: StateWithObjectPayload<D>, action: AnyAction & {  payload: D }) {
    const { flushOnError = false } = options;
    console.log('UPDATE REDUCER', action)
    switch (action.type) {
      case `${baseName}/UPDATE_START`:

        return {
          ...state,
          loadingId: action.payload?.loadingId,
          isLoading: true,
          isError: false,
          isInitLoading: false
        };

      case `${baseName}/UPDATE_ERROR`:
        return {
          ...state,
          isLoading: false,
          isInitLoading: false,
          isError: true,
          error: action.payload,
          data: flushOnError ? initialState.data : state.data,
        };
      case `${baseName}/UPDATE_SUCCESS`: {
        console.log(baseName, 'UPDATE SUCCESS', action)
        return {
          ...state,
          isLoading: false,
          isInitLoading: false,
          isError: false,
          data: {
            ...state.data,
            ...{[action.payload.id]: _.cloneDeep(action.payload)},
          },
        };
      }

      default:
        return state;
    }
  };
}

export default createUpdateWithKeyReducer;
